import type { FaireProductEntity } from "../../entity_types/product";

export const p_gp8amfpncv: FaireProductEntity = {
  token: "p_gp8amfpncv",
  type: "product",
  name: "1 Carat Real Diamond Tennis Bracelet In Sterling Silver",
  brandToken: "b_waxraygc8s",
  brandName: "Infinite Jewels",
  imageUrl:
    "https://cdn.faire.com/fastly/cf06ab3db6505d3ad27e8e8bb59a8c2007016a92455fd2edfaf7dbc0bc2373a4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d4775f42de3833448c1883b51b5d89c33c6e763d086968293533804c493b1e4b.jpeg",
    "https://cdn.faire.com/fastly/1eab93a3c216d154d35846b88c97f36c7b30aeb1de5398672345840b5a63b0bd.jpeg",
    "https://cdn.faire.com/fastly/67584928e7b5e3f28e42d95b4860228b95da1f2408109a5b6f3fb303cbee0820.jpeg",
    "https://cdn.faire.com/fastly/56615ba5dfe3e49123bf9d6e975ed7e3d34846d63a13e5afe1a9f74394859904.jpeg",
    "https://cdn.faire.com/fastly/6e7cf14ab8522feb6df6e996b8c2c2b14844fdb9f9a191932d1dcb004d7ac693.jpeg",
    "https://cdn.faire.com/fastly/282ad6efe50c2beb2d3a8aa3de6fdf2ac7b0ad5a1624f4e5e443aa901be71388.jpeg",
    "https://cdn.faire.com/fastly/f3ce12b3f4f9a9aca03c7e38855471d5aa7dd0278f0a3a951971484b57f2e4ff.jpeg",
    "https://cdn.faire.com/fastly/f433ba176ad1aec57de4d6518bdfd4eab641fd9d7759d4e6a8012c47dd07a93c.jpeg",
    "https://cdn.faire.com/fastly/6b8f4a3cb07e375a19f7c7ed5740d675eea3f50c0114d58dd040c1307e337bff.jpeg",
    "https://cdn.faire.com/fastly/598e54ba8074940c2f2449feb29c1a6c4545487a58de458a78885e2b216d6c41.jpeg",
    "https://cdn.faire.com/fastly/23d549591777d43ff0bca97d4cf1f02df6496bd02b5fa971a1d0fef5251e15c7.jpeg",
  ],
  priceDollars: 395,
  description:
    "This feminine and luxe tennis bracelet is made up of the most lovely, multifaceted rose cut diamonds, reminiscent of vintage-era Art Deco jewelry style. Set in real, solid .925 sterling silver links for timeless style, in your choice of precious metal finishes. The diamonds are naturally mined from conflict-free sources and give a wonderful sparkle. The diamonds are set in an illusion setting with faceted round bezel frames, to give a much bigger and more sparkly look. Each genuine stone is rose-cut and I3 clarity, which is at the lower end of the diamond color and clarity grading scale; the white diamonds are I-J color, and may appear more grey/brown and cloudy than as seen in images.\n\nThis bracelet is available in bracelet lengths 6, 7, 8, and 9. Available in white, rose, and yellow.",
  tags: [],
  msrpDollars: 1975,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:50.845Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
